export const getXapValue = val => ({
  url: '/kjarni/api/v2/XapValues',
  method: 'GET',
  params: {
    $filter: `XapValueName eq '${val}'`,
  },
});

export const getWorkingHours = detailId => ({
  url: '/kjarni/api/v2/EmployeeDetailWorkingHours',
  method: 'GET',
  params: {
    $filter: `EmployeeDetailID eq ${detailId}`,
  },
});

export const getCafePurchases = (start, end, detailId) => ({
  url: `/kjarni/api/v2/TeriaEmployeeCafeteriaPurchases/GetPurchasesInPeriod(dateFrom=${start.format('YYYY-MM-DD')},dateTo=${end.format('YYYY-MM-DD')})?$filter=EmployeeDetailID eq ${detailId}`,
  method: 'GET',
});

export const getCafeGuestPurchases = (start, end, detailId) => ({
  url: `/kjarni/api/v2/TeriaEmployeeCafeteriaCompanyGuestPurchases/GetPurchasesInPeriod(dateFrom=${start.format('YYYY-MM-DD')},dateTo=${end.format('YYYY-MM-DD')})?$filter=EmployeeDetailID eq ${detailId}`,
  method: 'GET',
});

export const getStorePurchases = (start, end, detailId) => ({
  url: `/kjarni/api/v2/TeriaEmployeeStorePurchases/GetPurchasesInPeriod(dateFrom=${start.format('YYYY-MM-DD')},dateTo=${end.format('YYYY-MM-DD')})?$filter=EmployeeDetailID eq ${detailId}`,
  method: 'GET',
});

export const getStores = () => ({
  url: '/kjarni/api/v2/TeriaStores',
  method: 'GET',
});

export const getCafeterias = () => ({
  url: '/kjarni/api/v2/TeriaCafeterias',
  method: 'GET',
});



// WEBPACK FOOTER //
// ./src/sites/teria/api.js